import { SortOption, HotelSearchSource } from '@shared/constants/accommodations';
import type { AccommodationsScenario, ScenarioFlags } from './scenarios.types';

const SCENARIO_FLAGS: Readonly<Record<AccommodationsScenario, ScenarioFlags>> = {
  guest: {
    sourceName: HotelSearchSource.GUEST_MAP,
    skipCouplePicks: false,
    defaultSortOption: SortOption.COUPLES_PICKS,
    shouldFilterOutNonJoyRoomBlocks: false,
    shouldShowAllAccommodations: true,
    includeCouplesPicks: true,
    hideEventNameAndNote: false,
    showAvailableOnlyTooltip: false,
    showJoyTravelBenefitsFilter: false,
    shouldShowVenueMapPin: true,
    showFundSavingsSort: false,
  },
  admin: {
    sourceName: HotelSearchSource.ADMIN_MAP,
    skipCouplePicks: false,
    defaultSortOption: SortOption.TOP_MATCHES,
    shouldFilterOutNonJoyRoomBlocks: true,
    shouldShowAllAccommodations: false,
    includeCouplesPicks: false,
    hideEventNameAndNote: true,
    showAvailableOnlyTooltip: true,
    showJoyTravelBenefitsFilter: true,
    shouldShowVenueMapPin: true,
    showFundSavingsSort: false,
  },
  ota: {
    sourceName: HotelSearchSource.OTA,
    skipCouplePicks: true,
    defaultSortOption: SortOption.TOP_MATCHES,
    shouldFilterOutNonJoyRoomBlocks: false,
    shouldShowAllAccommodations: false,
    includeCouplesPicks: false,
    hideEventNameAndNote: true,
    showAvailableOnlyTooltip: false,
    showJoyTravelBenefitsFilter: false,
    shouldShowVenueMapPin: false,
    showFundSavingsSort: false,
  },
  // Guest-facing flow; flags mirror `guest`. Reuses GUEST_MAP so cash-fund stays in guest_map UTM funnels (segment via the experiment flag); a dedicated CASH_FUND source is a future analytics decision (TRAV-3348).
  cashFund: {
    sourceName: HotelSearchSource.GUEST_MAP,
    skipCouplePicks: false,
    defaultSortOption: SortOption.HIGHEST_FUND_SAVINGS,
    shouldFilterOutNonJoyRoomBlocks: false,
    shouldShowAllAccommodations: true,
    includeCouplesPicks: true,
    hideEventNameAndNote: false,
    showAvailableOnlyTooltip: false,
    showJoyTravelBenefitsFilter: false,
    shouldShowVenueMapPin: true,
    showFundSavingsSort: true,
  },
};

export const resolveScenarioFlags = (variant: AccommodationsScenario): ScenarioFlags => SCENARIO_FLAGS[variant];
